<!--<div class="button-wrapper">-->
<!--  <button-->
<!--    mat-raised-button-->
<!--    type="button"-->
<!--    [routerLink]="['/lead-generation', 'projects', currentProjectId, 'creator', 'popup']"-->
<!--    color="primary">{{ 'LEAD_GENERATION.CREATOR.BUBBLE.SWITCH_TO_POPUP' | translate }}-->
<!--  </button>-->
<!--</div>-->
<div class="grid-container">
<!--  <cc-lg-box-type class="box-type" [popupSettings]="popupSettings"></cc-lg-box-type>-->
  <cc-lg-close-type class="close-type" [popupSettings]="popupSettings"></cc-lg-close-type>
  <cc-lg-theme-color class="theme-color" [popupSettings]="popupSettings"></cc-lg-theme-color>
  <cc-lg-position-box class="position-box" [positionSettings]="popupSettings.controls.position"></cc-lg-position-box>
<!--  <cc-lg-font-box class="font-box" [popupSettings]="popupSettings"></cc-lg-font-box>-->
  <cc-lg-text-box class="text-box" [popupSettings]="popupSettings"></cc-lg-text-box>
<!--  <cc-lg-country-code class="forced-country-code" [popupSettings]="popupSettings"></cc-lg-country-code>-->

<!--  <cc-simple-code-box-->
<!--    class="html-box"-->
<!--    title="HTML"-->
<!--    mode="html"-->
<!--    [content]="popupSettings.get('customHTML').value"-->
<!--    (codeChanged)="onChangeEditorCode($event, 'customHTML')">-->
<!--  </cc-simple-code-box>-->

<!--  <cc-simple-code-box-->
<!--    class="css-box"-->
<!--    title="CSS"-->
<!--    mode="css"-->
<!--    [content]="popupSettings.get('customCSS').value"-->
<!--    (codeChanged)="onChangeEditorCode($event, 'customCSS')">-->
<!--  </cc-simple-code-box>-->

  <div class="mobile-padding">
    <button
      mat-raised-button
      class="mobile-only pull-right"
      type="button"
      (click)="saveDb()"
      color="primary-full">
      {{'LEAD_GENERATION.CREATOR.BUBBLE.PUBLISH' | translate}}
    </button>
  </div>
  <div class="live-preview">
    <div class="live-preview-container">
      <div class="floating">
        <cc-lg-live-preview-bubble></cc-lg-live-preview-bubble>
        <button
          mat-raised-button
          class="desktop-only pull-right"
          type="button"
          (click)="saveDb()"
          color="primary-full">
          {{ 'LEAD_GENERATION.CREATOR.BUBBLE.PUBLISH' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
